import { Link } from "react-router-dom";
import { t } from "../i18n";

export function NotFoundPage() {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="text-center">
        <h1 className="text-6xl font-extrabold text-rose-500 mb-4">404</h1>
        <p className="text-gray-500 text-lg mb-8">{t("notFoundTitle")}</p>
        <Link
          to="/"
          className="inline-flex px-6 py-3 bg-rose-500 text-white rounded-xl font-semibold hover:bg-rose-600 transition-colors"
        >
          {t("notFoundGoHome")}
        </Link>
      </div>
    </div>
  );
}
